import React, { useState, useEffect } from "react";
import { Row, Col, List } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const featuresDetailsStyle = {
  textAlign: "center",
  minHeight: "100vh",
  padding: "50px 110px 100px 110px",
  color: "#000",
  backgroundColor: "#fff",
};

function FeaturesDetails() {
  const [paddingStyle, setPaddingStyle] = useState({
    padding: "50px 110px 100px 110px",
  });

  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Mobile view
        setPaddingStyle({
          padding: "50px 20px 100px 20px",
        });
        setIsMobile(true);
        setIsTab(false);
      } else if (window.innerWidth <= 1024) {
        // Tablet view
        setPaddingStyle({
          padding: "50px 40px 100px 40px",
        });
        setIsMobile(false);
        setIsTab(true);
      } else {
        // Desktop view
        setPaddingStyle({
          padding: "50px 110px 100px 110px",
        });
        setIsMobile(false);
        setIsTab(false);
      }
    };

    // Set initial padding based on current window size
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ ...featuresDetailsStyle, ...paddingStyle }}>
      <h1>Join Us To Get Easy And Fast Growth</h1>
      <img src={require("../../assets/images/OPTIX360.png")} alt="featuresDetails" style={{ width: "100%", height: "auto", }} />

      {/* Multiple Warehouse / Shopes */}
      <Row style={{ paddingTop: "80px" }} gutter={[24, 24]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "left" }}>
          <h2 style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "20px" }}>Multiple Warehouse / Shopes</h2>
          <p style={{ fontSize: "16px", color: "rgb(75 85 99)", lineHeight: "24px" }}>Manage your multiple store or warehouse. You can directly receive <br /> your warehouse order from online url.</p>
          <List
            style={{ border: "none", color: "#000" }}
            renderItem={(item) => (
              <List.Item style={{ border: "none", padding: "8px 0", color: "#000", fontSize: "16px" }}>
                <CheckCircleOutlined style={{ color: "#000", marginRight: 10 }} />
                {item}
              </List.Item>
            )}
            dataSource={["Add Multiple Stores", "Powerful Dashboard According To Stores", "Filter Purchases, Sales, Returns, Expenses According To Stores", "Receive Online Order From Multiple Stores"]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <img src={require("../../assets/images/website_rrydgq523mum7ii2u4of.webp")} alt="featuresDetails" style={{ width: "100%", height: "auto", }} />
        </Col>
      </Row>

      {/* Inventory / Stock Management */}
      {!isMobile ? (
        // Desktop/Tablet view
        <Row style={{ paddingTop: "80px" }} gutter={[24, 24]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img src={require("../../assets/images/website_4hooep1ngw7ezbvyxmyw.webp")} alt="featuresDetails" style={{ width: "100%", height: "auto", }} />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "left" }}>
            <h2 style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "20px" }}>Inventory / Stock Management</h2>
            <p style={{ fontSize: "16px", color: "rgb(75 85 99)", lineHeight: "24px" }}>Now manage your stock purchase, sales, sales return, and purchase <br /> returns in easy steps... Also record your payment in and out so that <br /> you can find your profit and loss...</p>
            <List
              style={{ border: "none", color: "#000" }}
              renderItem={(item) => (
                <List.Item style={{ border: "none", padding: "8px 0", color: "#000", fontSize: "16px" }}>
                  <CheckCircleOutlined style={{ color: "#000", marginRight: 10 }} />
                  {item}
                </List.Item>
              )}
              dataSource={["Purchase, Sales, Sales Return, Purchase Returns", "Manage Paid / Due Amount For Your Customers And Suppliers", "Get Inventory Stock Details", "Sales Products Using POS"]}
            />
          </Col>
        </Row>
      ) : (
        // Mobile view
        <Row style={{ paddingTop: "80px" }} gutter={[24, 24]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "left" }}>
            <h2 style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "20px" }}>Inventory / Stock Management</h2>
            <p style={{ fontSize: "16px", color: "rgb(75 85 99)", lineHeight: "24px" }}>Now manage your stock purchase, sales, sales return, and purchase <br /> returns in easy steps... Also record your payment in and out so that <br /> you can find your profit and loss...</p>
            <List
              style={{ border: "none", color: "#000" }}
              renderItem={(item) => (
                <List.Item style={{ border: "none", padding: "8px 0", color: "#000", fontSize: "16px" }}>
                  <CheckCircleOutlined style={{ color: "#000", marginRight: 10 }} />
                  {item}
                </List.Item>
              )}
              dataSource={["Purchase, Sales, Sales Return, Purchase Returns", "Manage Paid / Due Amount For Your Customers And Suppliers", "Get Inventory Stock Details", "Sales Products Using POS"]}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img src={require("../../assets/images/website_4hooep1ngw7ezbvyxmyw.webp")} alt="featuresDetails" style={{ width: "100%", height: "auto", }} />
          </Col>
        </Row>
      )}

      {/* Powerful Reports System */}
      <Row style={{ paddingTop: "80px" }} gutter={[24, 24]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "left" }}>
          <h2 style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "20px" }}>Powerful Reports System</h2>
          <p style={{ fontSize: "16px", color: "rgb(75 85 99)", lineHeight: "24px" }}>Optix360 comes with powerful reporting tools which will help you to be <br /> control your business. You can download reports in multiple formats <br /> so that you can use them later.</p>
          <List
            style={{ border: "none", color: "#000" }}
            renderItem={(item) => (
              <List.Item style={{ border: "none", padding: "8px 0", color: "#000", fontSize: "16px" }}>
                <CheckCircleOutlined style={{ color: "#000", marginRight: 10 }} />
                {item}
              </List.Item>
            )}
            dataSource={["View Reports and Download Them", "Payment, User, Store Wise Reports", "Profit & Loss reports", "Get Inventory Stock Details", "View Warehouse Reports Using FilterAnd Search"]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <img src={require("../../assets/images/website_qx3ee00qpexlljrersp4.png")} alt="featuresDetails" style={{ width: "100%", height: "auto", }} />
        </Col>
      </Row>
    </div>
  );
}

export default FeaturesDetails;